module.exports = __webpack_public_path__ + "static/media/official.87a1183.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/premier_league/official.mp4
// module id = ERC2
// module chunks = 1